/**
 * @param {string} url
 */
export function facebookShareUrl(url) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
}

/**
 * @param {string} url
 * @param {string} [text]
 */
export function twitterShareUrl(url, text = '') {
  const params = new URLSearchParams({ url });
  const trimmed = typeof text === 'string' ? text.trim() : '';
  if (trimmed !== '') {
    params.set('text', trimmed);
  }
  return `https://twitter.com/intent/tweet?${params.toString()}`;
}

/**
 * @param {string} url
 * @param {string} [text]
 */
export function whatsAppShareUrl(url, text = '') {
  const trimmed = typeof text === 'string' ? text.trim() : '';
  const message = trimmed !== '' ? `${trimmed} ${url}` : url;
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
}

/**
 * @param {string} url
 */
export function linkedInShareUrl(url) {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
}

/**
 * @param {string} url
 * @param {string} [subject]
 * @param {string} [body]
 */
export function emailShareUrl(url, subject = '', body = '') {
  const params = new URLSearchParams();
  const subj = typeof subject === 'string' ? subject.trim() : '';
  const bod =
    typeof body === 'string' && body.trim() !== ''
      ? body.trim()
      : url;
  if (subj !== '') {
    params.set('subject', subj);
  }
  params.set('body', bod);
  return `mailto:?${params.toString()}`;
}
